<template>
	<div style="text-align: left;" v-loading="loading">


        <EditorTitle
            :showReturnBtn="true"
            :returnLabel="i18n.tkey('return')"
            :showOperationBtn="false"
            :titleLabel="i18n.tkey('lang_inv_record')"
            @clickReturnBtn="clickReturnBtn"
        />

		<div class="inv-record-table-box">
			<div v-for="(v, i) in invataionList" :key="i + new Date().getTime()">
				<invitaionItem :invataionObj="v" :objIndex="i" />
			</div>

            <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="invataionList.length === 0">

            </el-empty>
		</div>

	</div>
</template>

<script setup>
	import {
		inject,
		onMounted,
		ref,
		toRef
	} from "vue";
	import invitaionApi from "@/request/invitaionApi"

	import invitaionItem from "@/components/shopopee/invitaion/InvitaionItem"

	import {
		useUserinfo
	} from "@/stores/userinfo";
	import util from "@/util/util"
    import EditorTitle from "@/components/shopopee/common/editorTitle.vue";

	const i18n = inject("i18n")

	//響應機制的userinfo
	const userInfoRef = toRef(useUserinfo())
	const invataionList = ref([])

	const loading = ref(false)
	// const componentWidth = ref(375)

    const emits = defineEmits(["clickReturnBtn"])

	onMounted(() => {
		// componentWidth.value = proxy.$refs.instanceContent.offsetWidth
		getInvRecord()
	})

    function clickReturnBtn(){
        emits("clickReturnBtn")
    }

	function getInvRecord() {
		loading.value = true
		const request = invitaionApi.queryAdditionalrecord10InfoList
		const params = request.getParams()
		params.addinfo1 = userInfoRef.value.companycode
		request.send(
			params,
			fillRecord
		)
	}

	function fillRecord(res) {
		loading.value = false
		if (res.code == 200) {
			fillInvRecord(res.detail)
		}

	}

	function fillInvRecord(list) {
		invataionList.value = []
		list.forEach((v, i) => {
			const objInvrecord = {}
			objInvrecord.login = v.login
			objInvrecord.name = v.name
			objInvrecord.addinfo6 = v.addinfo6
			objInvrecord.password = v.password
			objInvrecord.addinfo3 = v.addinfo3
			objInvrecord.memberworkid = v.memberworkid
			objInvrecord.invLogin = util.isEmpty(v.invLogin) ? "" : v.invLogin
			objInvrecord.invName = util.isEmpty(v.invName) ? "" : v.invName
			objInvrecord.companyname = util.isEmpty(v.companyname) ? "" : v.companyname

			if (util.isEmpty(objInvrecord.name) || "null" == objInvrecord.name) {
				if (v.updatedid == 0) {
					objInvrecord.name = "未激活"
				} else {
					objInvrecord.name = "已註銷的賬戶"
				}
			}

			if (util.isEmpty(objInvrecord.addinfo6) || "null" == objInvrecord.addinfo6) {
				if (v.updatedid == 0) {
					objInvrecord.addinfo6 = "未激活"
				} else {
					objInvrecord.addinfo6 = ""
				}
			}

			if (util.isEmpty(objInvrecord.password) || "null" == objInvrecord.password) {
				if (util.isNotEmpty(v.addinfo12) && "null" != v.addinfo12) {
					objInvrecord.password = v.addinfo12
				} else {
					objInvrecord.password = ""
				}
			}

			invataionList.value.push(objInvrecord)

		})
	}
</script>

<style scoped>
    .inv-record-table-box {
        max-height: 100%;
        overflow-y: auto;
        padding: 10px;
        box-sizing: border-box;
    }
</style>